import {fetchDeliveryAddresses} from '@/service/delivery.address.service';
import type {DeliveryAddress} from 'dummen-shared';
import {defineStore} from 'pinia';
import {type Ref, ref} from 'vue';

export const useDeliveryAddressStore = defineStore('deliveryAddressStore', () => {

	const deliveryAddresses: Ref<DeliveryAddress[]> = ref([]);

	const initDeliveryAddresses = async () => {
		if (deliveryAddresses.value && deliveryAddresses.value.length > 0) {
			return;
		}

		try {
			const deliveryAddressResponse = await fetchDeliveryAddresses();

			deliveryAddresses.value = deliveryAddressResponse.deliveryAddresses ?? [];
		} catch (error) {
			console.error('Error fetching delivery addresses.', error);
		}
	};

	return {
		deliveryAddresses,
		initDeliveryAddresses
	};
});
